import update from 'immutability-helper';

export default function setProject(state, action) {
  // console.log('SET_CURRENT_PROJECT', action)

  return update(state, {
    project: {
      $set: action.data,
    },
    filters: {
      project_id: {
        $set: action.data.id,
      },
    },
  });
}
